import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";
import { CloseTemplateCallbacks } from "../OrganizationCloseTemplatesList";
import styles from "./CloseTemplateScheduleCountCell.module.scss";

type Meta = ViewTableMeta<CloseTemplateCallbacks, never>;

export const CloseTemplateScheduleCountCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, CloseTemplateRow, number>) => {
        const meta = (table.options.meta ?? {}) as Meta;
        const count = row.original.scheduleCount;
        const closeTemplateId = row.original.id;

        return (
            <ViewTableCell captureClicks className={styles.cell}>
                <Button
                    variant="secondary"
                    size="sm"
                    disabled={count === 0}
                    onClick={() =>
                        meta.callbacks?.onViewSchedules(closeTemplateId)
                    }
                >
                    {count}
                </Button>
            </ViewTableCell>
        );
    },
);
